module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "list"
  }, [(_vm.articleList.length > 0) ? _c('ul', {
    directives: [{
      name: "infinite-scroll",
      rawName: "v-infinite-scroll",
      value: (_vm.loadMore),
      expression: "loadMore"
    }],
    attrs: {
      "infinite-scroll-disabled": "loading",
      "infinite-scroll-distance": "50"
    }
  }, _vm._l((_vm.articleList), function(article, index) {
    return _c('li', {
      key: index,
      staticClass: "flex flex-main-justify",
      on: {
        "click": function($event) {
          return _vm.goPath(article)
        }
      }
    }, [(article.type === 'live') ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [(article.tags && article.type === 'subject') ? _c('span', {
      staticClass: "tag_label"
    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), (article.liveType != 3 && (article.liveImage || article.images)) ? _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      staticStyle: {
        "max-width": "100%"
      },
      attrs: {
        "src": article.liveImage || article.images[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('div', {
      class: ['status', 'status-' + article.liveStatus]
    })]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "flex flex-main-justify date"
    }, [_c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))]), _vm._v(" "), (article.hits > 0) ? _c('span', [_vm._v(_vm._s(article.hits) + "人参与")]) : _vm._e()])]) : _vm._e(), _vm._v(" "), (article.viewType === 'three') ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "title"
    }, [(article.tags && article.type === 'subject') ? _c('span', {
      staticClass: "tag_label"
    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "three-list flex"
    }, _vm._l((article.images), function(img) {
      return _c('div', {
        key: img,
        staticClass: "img",
        style: ({
          backgroundImage: 'url(' + img + ')'
        })
      })
    }), 0), _vm._v(" "), _c('div', {
      staticClass: "flex-default date",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [_c('div', {
      staticClass: "tag ellipsis"
    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.viewType === 'bannerSmall') ? _c('div', {
      staticStyle: {
        "width": "100%"
      }
    }, [_c('div', {
      staticClass: "img-frame-small"
    }, [(article.images) ? _c('div', {
      staticClass: "img-bac",
      style: ('background:url(' + article.images[0] + ') no-repeat;background-size:100%')
    }) : _vm._e()])]) : ((article.viewType === 'banner' || article.viewType === 'bigimage') && article.type != 'live') ? _c('div', {
      staticStyle: {
        "height": "100%",
        "width": "100%"
      }
    }, [(article.type === 'normal' || article.type === 'subject') ? _c('div', [_c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": article.image,
        "alt": ""
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [(article.tags && article.type === 'subject') ? _c('span', {
      staticClass: "tag_label"
    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(article.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-default date",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [_c('div', {
      staticClass: "tag ellipsis"
    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'video') ? _c('div', [_c('div', {
      staticClass: "title"
    }, [(article.tags && article.type === 'subject') ? _c('span', {
      staticClass: "tag_label"
    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": article.images[0],
        "alt": ""
      }
    }), _vm._v(" "), _c('i', {
      staticClass: "content-button"
    })]), _vm._v(" "), _c('div', {
      staticClass: "flex-default date",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [_c('div', {
      staticClass: "tag ellipsis"
    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : (article.type === 'theme') ? _c('div', [(article.images) ? _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": article.images[0],
        "alt": ""
      }
    }), _vm._v(" "), (article.type === 'image') ? _c('div', {
      staticClass: "images-label"
    }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_c('span', {
      staticClass: "tag_theme"
    }, [_vm._v("#话题")]), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(article.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex-default date",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [_c('div', {
      staticClass: "tag ellipsis"
    }, [(article.source) ? _c('span', [_vm._v(_vm._s(article.source))]) : _vm._e()]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _c('div', [(article.images) ? _c('div', {
      staticClass: "pic-wrap"
    }, [_c('img', {
      attrs: {
        "src": article.images[0],
        "alt": ""
      }
    }), _vm._v(" "), (article.type === 'image') ? _c('div', {
      staticClass: "images-label"
    }, [_vm._v(_vm._s(article.medias && article.medias.length > 0 ? article.medias.length : 0) + "图")]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "description",
      domProps: {
        "innerHTML": _vm._s(article.description)
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "flex date ellipsis"
    }, [(article.source) ? _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(article.source))]) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "tag"
    }, [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])])]) : [(article.type != 'live') ? _c('div', {
      staticClass: "info"
    }, [_c('div', {
      class: ["title", "mult_line_ellipsis", article.images && article.images.length > 0 ? "min_height" : ""]
    }, [(article.tags && article.type === 'subject') ? _c('span', {
      staticClass: "tag_label_2"
    }, [_vm._v(_vm._s(article.tags))]) : _vm._e(), _vm._v(_vm._s(article.listTitle || article.title))]), _vm._v(" "), _c('div', {
      staticClass: "flex date"
    }, [_c('div', {
      staticClass: "tag ellipsis",
      staticStyle: {
        "justify-content": "flex-start"
      }
    }, [_c('span', {
      domProps: {
        "innerHTML": _vm._s(article.source)
      }
    })]), _vm._v(" "), _c('time', [_vm._v(_vm._s(_vm._f("dateCompared")(_vm.getDate(article.date))))])])]) : _vm._e(), _vm._v(" "), (article.images && article.viewType != 'noimage' && article.type != 'live') ? _c('div', {
      staticClass: "thumbnail",
      style: ({
        backgroundImage: 'url(' + article.images[0] + ')'
      })
    }, [(article.type == 'video' && article.medias) ? _c('i', {
      staticClass: "video-icon"
    }, [_vm._v(_vm._s(article.medias[0].times))]) : _vm._e(), _vm._v(" "), (article.type == 'image' && article.medias) ? _c('i', {
      staticClass: "image-icon"
    }, [_vm._v(_vm._s(article.medias.length))]) : (article.type == 'audio' && article.medias) ? _c('i', {
      staticClass: "audio-icon"
    }, [_vm._v(_vm._s(article.medias[0].times))]) : _vm._e()]) : _vm._e()]], 2)
  }), 0) : _c('div', {
    staticClass: "null-data"
  }, [_vm._v("暂无相关内容")]), _vm._v(" "), (_vm.loading) ? _c('p', {
    staticClass: "loading"
  }, [_c('spinner', {
    attrs: {
      "type": "fading-circle"
    }
  }), _vm._v("\n        加载中...\n    ")], 1) : _vm._e(), _vm._v(" "), (_vm.isAll) ? _c('p', {
    staticClass: "loading"
  }, [_vm._v("已显示全部内容")]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-d9080016!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/news_stream/theme-list-article.vue
// module id = 867
// module chunks = 2